import { VideoType } from 'components/layout/Video/types';

import Component from './component';

Component.defaultProps = {
    videoType: VideoType.Video,
};
export default Component;